module.exports = __webpack_public_path__ + "static/media/YB5F18_6.c89d1757.jpg";